import React from 'react';
import { useChat } from '../context/ChatContext'; // Corrected import path
import ProfilePicture from './ProfilePicture';
import useIsMobile from '../hooks/useIsMobile';
//ChatDrawer is a component that displays the chat drawer, which is a list of all the chats the user has had

function ChatDrawer({ onSelect, onClose }) { // Corrected function declaration syntax
  const { rooms, currentUser } = useChat();
  const isMobile = useIsMobile();
  return (
    <div style={{
      position:'fixed', right:0, top:0, bottom:0, width: isMobile ? 'min(88vw, 360px)' : '320px',
      background:'var(--surface-card)',
      borderLeft:'1px solid var(--border-subtle)',
      boxShadow:'-4px 0 24px rgba(32,32,32,0.08)',
      zIndex:2500, overflowY:'auto', padding:'1rem',
      fontFamily:'var(--font)',
      transform:'translateX(100%)', animation:'slideInDrawer .25s ease-out forwards'
    }}>
      <style>{`@keyframes slideInDrawer{from{transform:translateX(100%);}to{transform:translateX(0);} }`}</style>
      <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'1rem', paddingBottom:'0.75rem', borderBottom:'1px solid var(--border-subtle)'}}>
        <h3 style={{margin:0, color:'var(--maroon)', fontWeight:700, fontSize:'1rem', letterSpacing:'-0.3px', fontFamily:'var(--font-heading)'}}>Chats</h3>
        <button onClick={onClose} style={{border:'1px solid var(--border-subtle)', background:'transparent', borderRadius:'50%', width: isMobile ? 40 : 28, height: isMobile ? 40 : 28, fontSize: isMobile ? '1.3rem' : '1rem', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', color:'var(--text-muted)', flexShrink:0}}>×</button>
      </div>
      {rooms.length === 0 && (
        <div style={{ textAlign:'center', color:'var(--text-soft)', fontSize:'0.875rem', padding:'2rem 1rem', lineHeight:1.5 }}>
          No conversations yet. Start a chat from a listing to coordinate a campus pickup.
        </div>
      )}
      {rooms.map(r=>{
        const other = r.participants.find(p=>p._id!==currentUser._id);
        return (
          <div key={r._id} style={{
            padding:'0.6rem 0.75rem', 
            borderRadius:'10px', 
            marginBottom:'0.4rem', 
            cursor:'pointer', 
            background:'var(--surface-panel)',
            border:'1px solid transparent',
            display: 'flex',
            alignItems: 'center',
            gap: '0.75rem',
            transition:'background 150ms ease, border-color 150ms ease',
          }}
          onMouseOver={e=>{e.currentTarget.style.background='var(--maroon-light)'; e.currentTarget.style.borderColor='var(--maroon-border)';}}
          onMouseOut={e=>{e.currentTarget.style.background='var(--surface-panel)'; e.currentTarget.style.borderColor='transparent';}}
          onClick={()=>onSelect(r)}> 
            <ProfilePicture 
              src={other?.profilePicture}
              alt={other?.displayName || 'User'}
              size="small"
              fallbackColor="var(--text-soft)"
            />
            <div style={{flex: 1, minWidth: 0}}>
              <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <span style={{fontWeight: 600, color:'var(--text-strong)'}}>{other?.displayName||'User'}</span>
                {r.unread>0 && <span style={{background:'var(--maroon)', color:'#fff', borderRadius:'12px', padding:'0 6px', fontSize:'0.75rem', fontWeight:600}}>{r.unread}</span>}
              </div>
              <div style={{fontSize:'0.8rem', color:'var(--text-soft)', whiteSpace:'nowrap', overflow:'hidden', textOverflow:'ellipsis'}}>{r.lastMessage}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default ChatDrawer; 